import ProjectCard from './project_card';

export default ProjectCard;
